/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable @next/next/no-img-element */
"use client";

// import React, { useState } from "react";
import {
  FaTwitter,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
// import axios from "axios";
// import toast from "react-hot-toast";
// const API = process.env.NEXT_PUBLIC_API_URL;

const Footer = () => {
  // const [email, setEmail] = useState("");
  // const [loading, setLoading] = useState(false);

  // const handleSubscribe = async () => {
  //   if (!email.trim()) {
  //     toast.error("Please enter your email address");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const res = await axios.post(`${API}/api/v1/subscribe`, {
  //       email,
  //     });

  //     if (res.data.success) {
  //       toast.success(" You’re subscribed successfully!");
  //       setEmail("");
  //     } else {
  //       toast.error(res.data.message || "Subscription failed");
  //     }
  //   } catch (err: any) {
  //     toast.error(err.response?.data?.message || "Something went wrong");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <footer className="bg-[#4177BC] text-white">
      {/* --- Subscribe Section --- */}
    {/*
<div className="bg-[#2D6BBA] px-4 sm:px-8 lg:px-16 py-10">
  <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-center md:text-left">
    
    <div className="w-full md:w-auto mb-4 md:mb-0 md:self-start ">
      <h3 className="text-lg inter-medium mb-1">Subscribe Now</h3>
      <p className="text-sm text-white/80 inter-regular">
        Don’t miss our future updates! Get Subscribed Today!
      </p>
    </div>

    <div className="flex items-center gap-2 w-full md:w-auto justify-center md:justify-end md:self-end">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        className="px-4 py-2 rounded-md text-gray-700 w-full sm:w-72 outline-none border bg-[#FFFFFF] focus:border-[#4177BC]"
      />
      <button
        onClick={handleSubscribe}
        disabled={loading}
        className={`${
          loading
            ? "opacity-70 cursor-not-allowed"
            : "hover:bg-white hover:text-black"
        } bg-[#EB9C2C] inter-regular text-white font-semibold px-6 py-2 rounded-md transition-all duration-300 w-full sm:w-auto`}
      >
        {loading ? "Subscribing..." : "Subscribe"}
      </button>
    </div>

  </div>
</div>
*/}


      {/* --- Main Footer Content --- */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 lg:px-0 px-5 py-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="/asklocal-footer.png"
              alt="AskLocal Logo"
              className="w-auto h-auto"
            />
          </div>
          <p className="text-sm text-white/90 inter-regular leading-relaxed">
            17415 Northwood Avenue, Ste 201 <br />
            Lakewood, Ohio 44107
          </p>
        </div>

        <div>
          <h3 className="font-semibold mb-4 inter-semibold">Quick Link</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/about-us" className="hover:underline">
                About Us
              </a>
            </li>
            <li>
              <a href="/blogs" className="hover:underline">
                Blog
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:underline">
                Contact Support
              </a>
            </li>
            <li>
              <a href="/faq" className="hover:underline">
                FAQ
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold mb-4 inter-semibold">Latest Update</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#" className="hover:underline inter-regular">
                The Beginner&apos;s Guide to Buying a Home
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline inter-regular">
                Essential Home Inspection Tips You Should Know!
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline inter-regular">
                Smart Money Moves: How Mortgages Can Work for You
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold mb-4 inter-semibold inter-regular">
            Contact
          </h3>
          <p className="text-sm text-white/90 mb-2 inter-regular">
            Concierge@asklocal.com
          </p>
          <p className="text-sm text-white/90 mb-6 inter-regular">
            1-833-512-4663
          </p>
        </div>
   </div>
      {/* --- Bottom Bar --- */}
      <div className="py-5 px-6 border-t border-white/20 container mx-auto">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-white/80 mb-4 md:mb-0 text-center md:text-left inter-regular">
            Copyright © 2026 AskLocal. | All Rights Reserved. |{" "}
            <span className="relative group inline-block">
              <a
                href="https://yasinmunn.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#EB9C2C] hover:underline transition"
              >
                Developed by Yasin
              </a>

              {/* Hover tooltip */}
              <span className="absolute left-1/2 -translate-x-1/2 -top-8 hidden group-hover:block bg-[#EB9C2C] text-white inter-semibold text-xs px-2 py-1 rounded-md shadow-md whitespace-nowrap">
                Visit now
              </span>
            </span>
          </p>

          <div className="flex items-center space-x-4 text-lg">
            <a
              href="https://www.linkedin.com/company/asklocalmarketplace/"
              className="hover:text-[#d8e0f0]"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.facebook.com/AskLocalMarketplace"
              className="hover:text-[#d8e0f0]"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/asklocalmarketplace?igsh=MXJ0d3loMjVmYjc5aw=="
              className="hover:text-[#d8e0f0]"
            >
              <FaInstagram />
            </a>
            <a href="#" className="hover:text-[#d8e0f0]">
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
